import DisplayManager from './DisplayManager'

export default DisplayManager

export { useDisplayManager } from './DisplayManagerContext'
